import React, { useEffect, useRef, useState } from 'react';
import './ssmateagenteanim.css';

/* Hero "Agente SSMATE al lavoro" — SINCRONA con l'operazione reale.
   - running: radar in scansione ("leggo il presidio") sull'azienda corrente.
   - ad ogni CF verificato (prop `flash` cambia) -> badge lucchetto REALE dal centro (~1.6s).
   - standby/attesa: radar in pausa. */

const LOCK = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);

export default function SsmateAgenteAnim({ attivo = true, standby = false, esito, flash }) {
  const [result, setResult] = useState(false);
  const firstFlash = useRef(true);

  useEffect(() => {
    if (flash == null) return undefined;
    if (firstFlash.current) { firstFlash.current = false; return undefined; }
    setResult(true);
    const id = setTimeout(() => setResult(false), 1600);
    return () => clearTimeout(id);
  }, [flash]);

  const dim = !attivo || standby;
  const vc = esito?.color || 'var(--accent)';
  const label = esito?.label || 'PRESIDIO';

  return (
    <div className={`ssa${result ? ' ph3' : ''}${dim ? ' dim' : ''}`}>
      <div className="ssa-radar">
        <div className="ssa-orbit" />
        <div className="ssa-ring r1" /><div className="ssa-ring r2" /><div className="ssa-ring r3" />
        <div className="ssa-sat" />
        <div className="ssa-core">{React.cloneElement(LOCK, { style: { width: 34, height: 34, color: 'var(--accent)' } })}</div>
      </div>
      <div className="ssa-ov">
        <div className={`ssa-layer${(!result && attivo && !standby) ? ' on' : ''}`}>
          <div className="ssa-scan"><i /><i /><i /> leggo il presidio commerciale</div>
        </div>
        <div className={`ssa-layer${(!result && dim) ? ' on' : ''}`}>
          <span className="ssa-lbl">{standby ? 'pausa anti-blocco…' : 'in attesa…'}</span>
        </div>
      </div>
      <div className={`ssa-verdict${result ? ' pop' : ''}`} style={{ '--vc': vc }}>
        <div className="ssa-badge" style={{ '--vc': vc }}>
          {React.cloneElement(LOCK, { width: 19, height: 19 })}<b>{label}</b>
        </div>
      </div>
    </div>
  );
}
